const wait = (milliseconds: number) =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise((resolve) => setTimeout(resolve, milliseconds));

export const simulateRequest = async () => {
  const awaitedTime: number = Math.floor(Math.random() * 640) + 10;
  await wait(awaitedTime);
};
